module.exports = __webpack_public_path__ + "static/media/bg.597e8ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/bg.png
// module id = 188
// module chunks = 0